import $ from 'jquery';

class CompanyMerge {
	

	constructor() {

		$("#edit-companies input[type=checkbox]").change(e => {
			$("#merge-button").attr("disabled", "disabled");

			let count = 0
			let names = [];
			$("#edit-companies input[type=checkbox]").each((i, ee) => {
				if ($(ee).prop("checked")) {
					count++;
					names.push({name: $(ee).data("name"), count: $(ee).data("count")});
				}

				if (count >= 2) {
					$("#merge-button").attr("disabled", false);
				}
			});

			let text = $("<p></p>").html("Merging ");
			let links = names.map((el) => {
				let link = $("<a href=#></a>").html(el.name + " (" + el.count + ")").click(a => {
					a.preventDefault();
					$("#newname").val(el.name);
				});
				return $("<span></span>").html(link).append(", ");
			})

			$(text).append(links).append(" into:");

			$("#merge-info").html(text);
		});

		$("#doMergeComapnies").click(e => {
			e.preventDefault();

			let names = [];
			$("#edit-companies input[type=checkbox]").each((i, ee) => {
				if ($(ee).prop("checked")) {
					names.push($(ee).data("name"));
				}
			});

			let target = $("#newname").val();

            try {
                window.localStorage.setItem("scrollLocation", document.documentElement.scrollTop)
            } catch(ex) {
                console.log("Error setting")
            }

			$.ajax({data: {op: "mergeCompanies", target: target, names: names}});

		});

		$("#doMergeBrands").click(e => {
			e.preventDefault();

			let names = [];
			$("#edit-companies input[type=checkbox]").each((i, ee) => {
				if ($(ee).prop("checked")) {
					names.push($(ee).data("name"));
				}
			});

			let target = $("#newname").val();

			try {
				window.localStorage.setItem("scrollLocation", document.documentElement.scrollTop)
			} catch(ex) {
				console.log("Error setting")
			}

			$.ajax({data: {op: "mergeBrands", target: target, names: names}}, {noredirect: 1});

		});

		let loc = window.localStorage.getItem("scrollLocation")
		console.log(loc);
		if (loc && !isNaN(loc)) {
            window.localStorage.setItem("scrollLocation", null);
            document.documentElement.scrollTop = loc;
		}


	}


}

export default CompanyMerge;

